import { render, staticRenderFns } from "./LeftAside.vue?vue&type=template&id=46a33a06&scoped=true"
import script from "./LeftAside.vue?vue&type=script&lang=js"
export * from "./LeftAside.vue?vue&type=script&lang=js"
import style0 from "./LeftAside.vue?vue&type=style&index=0&id=46a33a06&prod&lang=scss&scoped=true"
import style1 from "./LeftAside.vue?vue&type=style&index=1&id=46a33a06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a33a06",
  null
  
)

export default component.exports